module.exports = __webpack_public_path__ + "static/media/color-accessibility.6bb9b55e.svg";